import React from 'react';
import { Grid } from 'semantic-ui-react';

const MainPage = () => {

  return (
    <Grid.Row className='page-content'>
      <Grid.Column >
        <div class='segment-shadow'>
          VISIUM LOAD
        </div>
        <div class='segment-shadow'>
        <p>
          Welcome to the Visium Load Testing Platform!
        </p>
        <p>
          This platform is designed to help you create, manage, and monitor load tests efficiently.
        </p>
        <p>
          You can navigate through various sections to create test suites, manage test runs, and monitor your runs.
        </p>
        <p>
          If you need help, refer to the <a href='https://support.visiumlabs.com' target="_blank" rel="noopener noreferrer">documentation or contact support.</a>
        </p>
        <p>
          Thank you for using Visium Load!
        </p>
        </div>
      </Grid.Column>
    </Grid.Row>
  );
};

export default MainPage;